/**
 * stockInLimits.js — client-side limits that MUST match the backend's.
 *
 * A truly shared module is not possible across these two packages, so the constants are
 * mirrored — and each side names the other. That cross-reference is the whole point: the
 * next person to change one has the other's path in front of them.
 */

/**
 * Hard ceiling on items in one Stock-In submission.
 *
 * MUST equal MAX_ITEMS_PER_SUBMISSION in backend/middleware/validation.js. If the client's
 * number is the larger one, a 101-item bill passes every check the user can see and then
 * dies at submit on a raw Joi error they cannot act on.
 */
export const MAX_ITEMS_PER_SUBMISSION = 100;
